// cambiar nombre del logo y fondo segun la liga
import logo from '@/assets/images/logo/logo-playgol.png'
import fondoLogin from '@/assets/images/pages/login-playgol.svg'
// NO SE TOCA VARIABLES DE ENTORNO EN .ENV
const host = process.env.VUE_APP_HOST
const hostApi = process.env.VUE_APP_HOST_API
const hostProcesarImagenes = process.env.VUE_APP_HOST_PROCESAR_IMAGENES
// CAMBIAR SEGUN LA LIGA Y LA VERSION
const folder = 'debugv7_0_0'
const folderDocs = 'docs_debug'
const version = '7.0.0'
const storagePrefix = 'user_pgol_demo_'
const idCliente = process.env.VUE_APP_ID_CLIENTE
const appNameShow = process.env.VUE_APP_MENU_TITLE.toUpperCase() || 'PLAYGOL'

export default {
  appName: appNameShow,
  logo,
  fondoLogin,
  // variables de conexion

  api: {
    URL: `${hostApi}index.php/${folder}/`,
    URL_ADMINISTRACION: `${hostApi}index.php/adminplaygol/`,
    URL_PROCESO_IMAGENES: `${hostProcesarImagenes}`,
    URL_CARNET: `${hostApi}`,
    URL_PDF: `${host}/${folderDocs}/`,
    URL_DOCS_PETICIONES: `${host}/docs_peticiones/`,
    URL_PROXY: `${hostApi}index.php/Proxy/image?url=`,
    VERSION: version,
    STORAGE_PREFIX: storagePrefix,
    ID_CLIENTE: idCliente,
  },

}
